<div [id]="text" class="box h-14 w-60 mb-2 rounded flag" [ngClass]="{ 'selected': this.language === text }" (click)="changeLanguage(text)">
  <div class="flex h-full float-left pl-4">
    <div class="flex m-auto left-0">
      <img [src]="getImage()" [alt]="image" class="h-6 w-6" />
      <label class="pl-2 text-base font-" [ngClass]="{ 'font-bold': this.language === text, 'font-semibold': this.language !== text }">{{ literalService.get('languages.' + text, true) }}</label>
    </div>
  </div>
</div>
